'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var button = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  touchAction: 'manipulation',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  fontFamily: 'Source Sans Pro',
  borderRadius: '4px',
  textTransform: 'uppercase',
  variants: {
    primary: {
      bgColor: 'green.05',
      color: 'white'
    },
    white: {
      bgColor: 'white',
      color: 'grey.05'
    }
  },
  sizes: {
    "default": {
      padding: '9px 18px',
      fontSize: '11px',
      lineHeight: '14px',
      fontWeight: 'bold'
    },
    medium: {
      padding: '9px 18px',
      fontSize: '13px',
      lineHeight: '16px',
      fontWeight: 'bold'
    },
    big: {
      padding: '11px 22px',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: '600'
    }
  }
};

exports.default = button;
